import styled from "styled-components";
import { Modal } from "antd";

export const ModalPopup = styled(Modal)<{ top?: string }>`
  width: unset !important;

  .ant-modal-content {
    border-radius: 14px;

    .ant-modal-body {
      padding: 0 !important;

      > div {
        padding-bottom: 0 !important;
      }
    }
  }
`;

export const InnerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  overflow-y: auto;
`;

export const ContentWrapper = styled.div`
  padding: 26px 26px 86px 26px;

  img {
    max-width: 60vw;
    max-height: 80vh;
  }
`;

export const ButtonConfirm = styled.button`
  background: #653cd5;
  color: #ffffff;
  font-family: 'SpoqaHanSansNeo-Regular', 'Apple SD Gothic Neo', sans-serif;
  font-weight: 800;
  font-size: 22px;
  line-height: 100%;
  letter-spacing: -5%;
  text-align: center;
  width: 100%;
  height: 63px;
  border-bottom-right-radius: 14px;
  border-bottom-left-radius: 14px;
  position: absolute;
  bottom: 0;
  left: 0;
  padding: 12px;
`;
